var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "release-printer"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('br'), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "card-body1",
    staticStyle: {
      "margin-top": "-18px"
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.releasePrinterConfirmation()
      }
    }
  }, [_c('legend', [_vm._v("Release Printer")]), _vm._v(" "), _c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Hub Name")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bank'></i>"
    }
  }, [_c('Multiselect', {
    attrs: {
      "options": _vm.hublist,
      "name": "HubName",
      "id": "HubName",
      "placeholder": "Select Hub Name",
      "label": "text",
      "track-by": "value"
    },
    on: {
      "select": _vm.setSelectedHub
    },
    model: {
      value: (_vm.hubitem),
      callback: function($$v) {
        _vm.hubitem = $$v
      },
      expression: "hubitem"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v(_vm._s(_vm.hubloader))]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.hubnameerror))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Enter Printer's IP-Address")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-barcode'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.printerIPAddress),
      expression: "printerIPAddress"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        ip: true
      }),
      expression: "{required:true,ip:true }"
    }],
    ref: "printerIPAddress",
    class: {
      'form-control': true, 'error': _vm.errors.has('printerIPAddress')
    },
    attrs: {
      "name": "printerIPAddress"
    },
    domProps: {
      "value": (_vm.printerIPAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.printerIPAddress = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('printerIPAddress')),
      expression: "errors.has('printerIPAddress')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('printerIPAddress')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit",
      "disabled": _vm.isFormInvalid
    }
  }, [_c('span', {
    staticClass: "fa fa-print"
  }), _vm._v(" Release ")]), _vm._v("  \n                      "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        return _vm.resetData()
      }
    }
  }, [_c('span'), _vm._v("Reset")]), _vm._v("  \n                      ")])], 1)], 1)])], 1)], 1)])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "title": "Confirmation"
    },
    model: {
      value: (_vm.releasePrinterConfirmationModel),
      callback: function($$v) {
        _vm.releasePrinterConfirmationModel = $$v
      },
      expression: "releasePrinterConfirmationModel"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v("Are you sure you want to release printer "), _c('b', [_vm._v(_vm._s(_vm.printerIPAddress))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.releasePrinter
    }
  }, [_vm._v("Continue")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.cancelReleasePrinter
    }
  }, [_vm._v("Cancel")])])])])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e15ddf8","hasScoped":true}!./src/views/components/ReleasePrinter/releasePrinter.html
// module id = 2027
// module chunks = 2